import type { IEditorQuery } from './../../ricos-content-query';
import type { EditorPlugin } from './../../ricos-types';
import { Node_Type } from './../../ricos-types';

import { FloatingToolbarButton } from './floating-toolbar-button/floating-toolbar-button';
import { QuickActionsModal } from './modal/modal';
import { getTipTapExtensions } from './tiptap/extensions';
import type { QuickActionsEditorConfig } from './types';
import { QUICK_ACTIONS } from './types';

export const pluginQuickActions = (
  config: QuickActionsEditorConfig
):
  | EditorPlugin<QuickActionsEditorConfig, { QuickActionsModal: typeof QuickActionsModal }>
  | undefined => {
  return Object.keys(config).length > 0
    ? {
        config: config || {},
        type: QUICK_ACTIONS,
        tiptapExtensions: getTipTapExtensions(config),
        disableOnMobile: true,
        floatingToolbarButton: {
          Component: FloatingToolbarButton,
          priority: 0,
          isVisible: ({
            editorQuery,
            nodeId,
          }: {
            editorQuery: IEditorQuery['query'];
            nodeId?: string;
          }) => {
            const floatingPlusButtonActive = config?.activateOnFloatingPlusButton ?? false;
            if (!floatingPlusButtonActive) {
              return false;
            }

            if (
              !nodeId &&
              (editorQuery.isMultipleSelection() || editorQuery.isSingleRootTextBlock())
            ) {
              return true;
            }

            const isInsideTable = editorQuery.isChildOfNode(Node_Type.TABLE_CELL);

            if (isInsideTable || editorQuery.isListItem()) {
              return false;
            }

            return nodeId && editorQuery.isChildSingleTextBlock(nodeId);
          },
        },
        __exports: {
          QuickActionsModal,
        },
      }
    : undefined;
};
